let baseUrl="https://filter.luxwork.online/jp"
        // let baseUrl="http://localhost:8030"

// let baseUrl="https://9045.luxwork.online"
        let uuid = generateUUID();
                const CURRENT_URL = new URL(window.location.href)
        const paths = CURRENT_URL.pathname.split("/");
        let handle = paths[paths.length-1];// "flash-sale-louis-vuitton-bags";
        let CURRENT_PAGE = CURRENT_URL.searchParams.get("page")?parseInt(CURRENT_URL.searchParams.get("page")):1;
        let totalItems = 0;
        let CURRENT_SORT_BY=""
    
        let firstLoad=true;
     document.addEventListener("DOMContentLoaded", async () => {

        let initialWidth = window.innerWidth;
        changeFilterLocation(initialWidth)

        this.debouncedOnSubmit = debounce((event) => {
            const formData = new FormData(event.target.closest('form'));
             const searchParams = new URLSearchParams(formData).toString();
             const selectedValue = searchParams.replace("sort_by=","");
             const url = new URL(window.location.href);
            
            url.searchParams.set(`sort_by`, selectedValue);
            // 更新浏览器地址栏
            window.location.href=url;

       console.log(searchParams)
        // this.onSubmitHandler(event);
        }, 500);

        document.querySelector('.product-filter__form').addEventListener('input', this.debouncedOnSubmit.bind(this));


        // 监听宽度变化
        window.addEventListener('resize', () => {
            let newWidth = window.innerWidth;
            changeFilterLocation(newWidth)
        });

              const selectedValue = document.querySelector('#CollectionFiltersForm li.selected input[name="sort_by"]')?.value;
        
              // 获取其 value 属性的值
              if (selectedValue) {
                  CURRENT_SORT_BY = selectedValue;
              } else {
                  
              }
             window.addEventListener("popstate", (event) => {
                console.log("URL changed to:", window.location.href);
                // 在此处执行相关逻辑，例如重新加载数据
                handleUrlChange(window.location.href);
            });
           
            const originalPushState = history.pushState;
            history.pushState = function (state, title, url) {
                originalPushState.apply(this, arguments);
                console.log("URL changed to (pushState):", url);
                handleUrlChange(url);
            };
            
            const originalReplaceState = history.replaceState;
            history.replaceState = function (state, title, url) {
                originalReplaceState.apply(this, arguments);
                console.log("URL changed to (replaceState):", url);
              
                handleUrlChange(url);
            };
            
            const handleUrlChange = (url) => {
              if (!url.startsWith("https://luxuness.com")) {
                url="https://luxuness.com"+url
              }
              const url1 = new URL(url);
                
              
                let sortBy = url1.searchParams.get("sort_by");
                if(!sortBy)
                {
                  sortBy = selectedValue;
                }
                if(sortBy!=CURRENT_SORT_BY&&!firstLoad)
                {
                  CURRENT_SORT_BY= sortBy;
                  let filter = applyFiltersFromURL()
        
                  loadFilters(JSON.stringify(filter)).then(()=>{
                      let selected = getSelectedCheckboxValues(false)
                      renderSelectedFilters(selected);
                  })
                 loadProducts(CURRENT_PAGE,JSON.stringify(filter))
                  
                }
                firstLoad=false
                //根据新的 URL 执行操作
                console.log("Handle logic for URL:", url);
            };
       
            let filter = applyFiltersFromURL()
        
            loadFilters(JSON.stringify(filter)).then(()=>{
                let selected = getSelectedCheckboxValues(false)
                renderSelectedFilters(selected);
            })
           loadProducts(CURRENT_PAGE,JSON.stringify(filter))
            
        });
        var isMoble=false;
        function changeFilterLocation(width) {
            const filtersOuter = document.getElementById('lux-filters-outer');
            const filtersMobile = document.getElementById('lux-filters-mobile');
            const filtersPc = document.getElementById('lux-filters-pc');
            // if(width<=1280){
            //     if(!isMoble){
            //         isMoble=true
            //         filtersMobile.appendChild(filtersOuter); 
            //     }
            // }else{
            //     if(isMoble){
                    isMoble=false
                    filtersPc.appendChild(filtersOuter); 
                // }
            // }
        }
        
         // 获取 API 数据
         const fetchFilters = async (filter) => {
                if(filter)
                {
                    filter = encodeURIComponent(filter)
                }
                else{
                    filter=''
                }
                const response = await fetch(`${baseUrl}/shopify/open/searchFilter?handle=${handle}&filter=${filter}&uuid=${uuid}`);
                return await response.json();
            };
        // 加载商品数据和分页，返回 Promise
            const loadFilters = (filter) => {
                return new Promise(async (resolve, reject) => {
                    try {
                        
                        // 获取过滤器数据
                        const filtersData = await fetchFilters(filter);

                        // 渲染过滤器到页面
                        renderFilters(filtersData);

                        // 成功时返回过滤器数据
                        resolve(filtersData);
                    } catch (error) {
                        console.error('加载过滤器数据时出错:', error);
                        // 失败时返回错误信息
                        reject(error);
                    }
                });
            };
        // 渲染过滤器
        const renderFilters = (filters) => {
            const filtersContainer = document.getElementById("lux-filters");
                filtersContainer.innerHTML=""
                filters.forEach((filter) => {
                    // debugger
                    const section = document.createElement("div");
                    section.classList.add("lux-filter-section");

                
                    const title = document.createElement("h4");
                    title.setAttribute("id",filter.id)
                    title.setAttribute("name",filter.name)
                    title.setAttribute("type",filter.type)
                    title.className="active";
                    // title.textContent = filter.name || filter.id;

                  // 创建第一个 <span> 元素，并添加文本 "Price"
                    const spanPrice = document.createElement("span");
                    spanPrice.className = "inline-flex gap-10 align-center lh-normal";
                    spanPrice.textContent = filter.name || filter.id;
                    
                    // 创建第二个 <span> 元素，并在其中嵌套一个内层 <span>
                    const spanToggle = document.createElement("span");
                    spanToggle.className = "open-children-toggle inset-0 flex flex-end pointer";
                    
                    const innerSpan = document.createElement("span");
                    innerSpan.className = "icon_plus-animation";
                    innerSpan.innerHTML=`<svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="none"><path d="M11 5.5L5.5 6.55868e-08L-6.55868e-08 5.5L0.97625 6.47625L5.5 1.9525L10.0238 6.47625L11 5.5Z" fill="currentColor"></path></svg>`
                    // 如果需要，可以在 innerSpan 中设置文本内容或其他属性
                    spanToggle.appendChild(innerSpan);
                    
                    // 将这两个 span 添加到 title 中
                    title.appendChild(spanPrice);
                    title.appendChild(spanToggle);
                    section.appendChild(title);
                  

                    const sectionItem = document.createElement("div");
                    sectionItem.classList.add("lux-filter-section-items");
                    sectionItem.style.display="block";
                    section.appendChild(sectionItem);
                     // 渲染价格过滤器
                    if (filter.type === "price") {
                        // const section = document.createElement("div");
                        // section.classList.add("filter-section");

                        // const title = document.createElement("h4");
                        // title.textContent = "PRICE";
                        // section.appendChild(title);

                        // 创建输入框
                        const priceInputs = document.createElement("div");
                        priceInputs.classList.add("lux-filter-price-inputs");

                        const minInput = document.createElement("input");
                        minInput.type = "number";
                        minInput.id = "lux-filter-min-price";
                        minInput.placeholder = `￥ Min`;
                        minInput.value = filter.filterMin?filter.filterMin.toFixed(0):"";

                        const maxInput = document.createElement("input");
                        maxInput.type = "number";
                        maxInput.id = "lux-filter-max-price";
                        maxInput.placeholder = `￥ Max`;
                        maxInput.value = filter.filterMax?filter.filterMax.toFixed(0):"";

                        priceInputs.appendChild(minInput);
                        priceInputs.appendChild(maxInput);
                        sectionItem.appendChild(priceInputs);

                        // 创建滑块容器
                        const priceRangeContainer = document.createElement("div");
                        
                        
                        // 创建滑块容器
                        const priceRangeLabelContainer = document.createElement("div");
                        priceRangeLabelContainer.classList.add("lux-filter-price-range-label-container");

                        const minRangeLabel = document.createElement("span");
                        minRangeLabel.id = "lux-filter-min-range";
                        minRangeLabel.textContent = `￥${luxFilterFormatNumber(filter.filterMin?filter.filterMin.toFixed(0):filter.min.toFixed(0))}`;
                        priceRangeLabelContainer.appendChild(minRangeLabel)

                        const maxRangeLabel = document.createElement("span");
                        maxRangeLabel.id = "lux-filter-max-range";
                        maxRangeLabel.textContent = `￥${luxFilterFormatNumber(filter.filterMax?filter.filterMax.toFixed(0):filter.max.toFixed(0))}`;
                        priceRangeLabelContainer.appendChild(maxRangeLabel)

                        const rangeSlider = document.createElement("div");
                        rangeSlider.classList.add("lux-filter-range-slider");

                        const rangeMin = document.createElement("input");
                        rangeMin.type = "range";
                        rangeMin.id = "lux-filter-range-min";
                        rangeMin.min = filter.min;
                        rangeMin.max = filter.max;
                        rangeMin.value =  filter.filterMin?filter.filterMin:filter.min;

                        const rangeMax = document.createElement("input");
                        rangeMax.type = "range";
                        rangeMax.id = "lux-filter-range-max";
                        rangeMax.min = filter.min;
                        rangeMax.max = filter.max;
                        rangeMax.value = filter.filterMax?filter.filterMax:filter.max;

                        rangeSlider.appendChild(rangeMin);
                        rangeSlider.appendChild(rangeMax);
                        priceRangeContainer.appendChild(priceRangeLabelContainer);
                        priceRangeContainer.appendChild(rangeSlider);
                        // priceRangeContainer.appendChild(maxRangeLabel);

                        sectionItem.appendChild(priceRangeContainer);

                        // 将 section 添加到页面
                        const filtersContainer = document.getElementById("lux-filters");
                        filtersContainer.appendChild(section);



                        const minPriceInput = document.getElementById('lux-filter-min-price');
                        const maxPriceInput = document.getElementById('lux-filter-max-price');

                        // 初始化值
                        const minPrice = parseFloat(rangeMin.min);
                        const maxPrice = parseFloat(rangeMax.max);


                                                // 文本框输入时更新滑条值
                        minPriceInput.addEventListener('input', () => {
                            let value = parseFloat(minPriceInput.value);
                            if (isNaN(value) || value < minPrice) value = minPrice;
                            if (value > parseFloat(rangeMax.value)) value = parseFloat(rangeMax.value);

                            rangeMin.value = value;
                            minRangeLabel.textContent = `￥${luxFilterFormatNumber(value.toFixed(0))}`;
                            updateSliderBackground();
                        });

                        maxPriceInput.addEventListener('input', () => {
                            let value = parseFloat(maxPriceInput.value);
                            if (isNaN(value) || value > maxPrice) value = maxPrice;
                            if (value < parseFloat(rangeMin.value)) value = parseFloat(rangeMin.value);

                            rangeMax.value = value;
                            maxRangeLabel.textContent = `￥${luxFilterFormatNumber(value.toFixed(0))}`;
                            updateSliderBackground();
                        });

                        // 滑条拖动时更新文本框值
                        rangeMin.addEventListener('input', () => {
                            const value = parseFloat(rangeMin.value);
                            minPriceInput.value = value;
                            minRangeLabel.textContent = `￥${luxFilterFormatNumber(value.toFixed(0))}`;
                            if (value > parseFloat(rangeMax.value)) {
                                rangeMin.value = rangeMax.value;
                                minPriceInput.value = rangeMax.value;
                            }
                            updateSliderBackground();
                        });

                        rangeMax.addEventListener('input', () => {
                            const value = parseFloat(rangeMax.value);
                            maxPriceInput.value = value;
                            maxRangeLabel.textContent = `￥${luxFilterFormatNumber(value.toFixed(0))}`;
                            if (value < parseFloat(rangeMin.value)) {
                                rangeMax.value = rangeMin.value;
                                maxPriceInput.value = rangeMin.value;
                            }
                            updateSliderBackground();
                        });

                        // 更新滑条背景
                        function updateSliderBackground() {
                            const minPercent = ((rangeMin.value - minPrice) / (maxPrice - minPrice)) * 100;
                            const maxPercent = ((rangeMax.value - minPrice) / (maxPrice - minPrice)) * 100;

                            // 只设置条线的背景颜色，避免覆盖圆圈
                            rangeMin.style.background = `linear-gradient(to right, #ddd ${minPercent}%, #333 ${minPercent}%, #333 ${maxPercent}%, #ddd ${maxPercent}%)`;
                            rangeMax.style.background = rangeMin.style.background;
                        }
                        // 初始化滑块背景
                        updateSliderBackground();


                    }

                   // 渲染默认类型的复选框过滤器
                    if (filter.type === "availability") {
                        return;
                        if (filter.inStockLabel) {
                            const checkboxItem = document.createElement("div");
                            checkboxItem.classList.add("lux-filter-checkbox-item");

                            const label = document.createElement("label");
                            const checkbox = document.createElement("input");
                            checkbox.type = "checkbox";
                            checkbox.value = filter.inStock;

                            // 根据 item.selected 设置选中状态
                            checkbox.checked = filter.inStockDefault === true;

                            label.appendChild(checkbox);
                            label.appendChild(document.createTextNode(` ${filter.inStockLabel} `));//(${filter.inStockCount})
                            checkboxItem.appendChild(label);
                            sectionItem.appendChild(checkboxItem);
                        }
                         if (filter.preorderLabel) {
                            const checkboxItem = document.createElement("div");
                            checkboxItem.classList.add("lux-filter-checkbox-item");

                            const label = document.createElement("label");
                            const checkbox = document.createElement("input");
                            checkbox.type = "checkbox";
                            checkbox.value = filter.preorder;

                            // 根据 item.selected 设置选中状态
                            checkbox.checked = filter.preorderDefault === true;

                            label.appendChild(checkbox);
                            label.appendChild(document.createTextNode(` ${filter.preorderLabel} `));//(${filter.count})
                            checkboxItem.appendChild(label);
                            sectionItem.appendChild(checkboxItem);
                        }   
                       
                    }

                    // 渲染默认类型的复选框过滤器
                    if (filter.type === "default" && filter.counts) {
                      if(filter.id.indexOf("brand")>=0||filter.id.indexOf("subcategory")>=0)
                      {
                        filter.counts.sort((a, b) => a.value.localeCompare(b.value));
                      }
                      if (filter.id.indexOf("condition")>=0) {
                        const customOrder = ["新品・未使用品", "中古品-ほぼ新品", "中古品-非常に良い","中古品-良い", "中古品-可",  "中古品-難あり"];

                            filter.counts.sort((a, b) => {
                                return customOrder.indexOf(a.value) - customOrder.indexOf(b.value);
                            });

                      }
                        filter.counts.forEach((item) => {
                            const checkboxItem = document.createElement("div");
                            checkboxItem.classList.add("lux-filter-checkbox-item");

                            const label = document.createElement("label");
                            const checkbox = document.createElement("input");
                            checkbox.type = "checkbox";
                            checkbox.value = item.value;

                            // 根据 item.selected 设置选中状态
                            checkbox.checked = item.selected === true;

                            label.appendChild(checkbox);
                            label.appendChild(document.createTextNode(` ${item.value}`));// (${item.count})
                            checkboxItem.appendChild(label);
                            sectionItem.appendChild(checkboxItem);
                        });
                    }

                    filtersContainer.appendChild(section);
                });

                

                // 移除并重新添加监听器
                document.removeEventListener('change', handleCheckboxChange); // 移除监听器
                document.addEventListener('change', handleCheckboxChange); // 添加监听器

                // 价格输入框监听器
                const minPriceInput = document.getElementById('lux-filter-min-price');
                const maxPriceInput = document.getElementById('lux-filter-max-price');
                minPriceInput.removeEventListener('input', debouncedHandlePriceChange); // 移除监听器
                maxPriceInput.removeEventListener('input', debouncedHandlePriceChange);
                minPriceInput.addEventListener('input', debouncedHandlePriceChange); // 添加监听器
                maxPriceInput.addEventListener('input', debouncedHandlePriceChange);

                // 价格滑块监听器
                const rangeMinInput = document.getElementById('lux-filter-range-min');
                const rangeMaxInput = document.getElementById('lux-filter-range-max');
                rangeMinInput.removeEventListener('input', debouncedHandlePriceChange); // 移除监听器
                rangeMaxInput.removeEventListener('input', debouncedHandlePriceChange);
                rangeMinInput.addEventListener('input', debouncedHandlePriceChange); // 添加监听器
                rangeMaxInput.addEventListener('input', debouncedHandlePriceChange);
                
                // 折叠效果
                document.querySelectorAll('.lux-filter-section h4').forEach((header) => {
                    header.addEventListener('click', () => {
                        const content = header.nextElementSibling;
                        if (content.style.display === 'none' || content.style.display === '') {
                            content.style.display = 'block';
                            header.classList.add('active');
                        } else {
                            content.style.display = 'none';
                          header.classList.remove('active');
                        }
                    });
                });
            };

        // 获取选中的复选框值
        function getSelectedCheckboxValues(loadProduct) {
            const selectedValues = {};
            const selectedDisplayValues = {};
            // 遍历所有的 filter-section
            document.querySelectorAll('.lux-filter-section').forEach((section) => {
                const id = section.querySelector('h4').getAttribute("id");
                const name = section.querySelector('h4').getAttribute("name");
                const checkboxes = section.querySelectorAll('input[type="checkbox"]:checked');

                if (checkboxes.length > 0) {
                    selectedValues[id] = Array.from(checkboxes).map((checkbox) => checkbox.value);
                    
                    if (name=="在庫あり") {
                      selectedDisplayValues[name] = Array.from(checkboxes).map((checkbox) => checkbox.value==1?"在庫あり":"在庫なし");
                    }
                    else{
                      selectedDisplayValues[name] = Array.from(checkboxes).map((checkbox) => checkbox.value);
                    }
                }
            });
            const minPriceInput = document.getElementById('lux-filter-min-price');
            const maxPriceInput = document.getElementById('lux-filter-max-price');

            const minPrice = parseFloat(minPriceInput.value) || 0;
            const maxPrice = parseFloat(maxPriceInput.value) || 0;

            if(minPrice!=0||maxPrice!=0)
            { 
                let priceRange = {}
                if(minPrice!=0)
                {
                    priceRange.min = minPrice
                }
                if(maxPrice!=0)
                {
                    priceRange.max = maxPrice
                }
                selectedValues["price"]=priceRange
                selectedDisplayValues["price"]=priceRange
            }
           

            console.log("选中的复选框值:", selectedValues);
            
            updateURLParams(selectedValues)
          
            if(loadProduct)
            {
                loadProducts(CURRENT_PAGE,JSON.stringify(selectedValues))
            }
            // loadFilters(JSON.stringify(selectedValues))
            return selectedDisplayValues;
            
        }

        // 更新 URL 参数
        function updateURLParams(selectedValues) {
            const url = new URL(window.location.href);

            // 清除现有过滤器相关参数
            for (const key of [...url.searchParams.keys()]) {
                if (key.startsWith("filter.")||key.startsWith("page")) {
                    url.searchParams.delete(key);
                }
            }

            // 添加新的过滤器参数
            Object.keys(selectedValues).forEach((filterKey) => {
                if (filterKey === "price") {
                    // 处理价格区间
                    const { min, max } = selectedValues.price;
                    if (min) url.searchParams.set(`filter.luxwork.price.min`, min);
                    if (max) url.searchParams.set(`filter.luxwork.price.max`, max);
                } else {
                    // 处理其他复选框类型的过滤器
                    selectedValues[filterKey].forEach((value) => {
                        url.searchParams.append(`filter.${filterKey}`, value);
                    });
                }
            });
            if (CURRENT_PAGE>1) {
               url.searchParams.append(`page`, CURRENT_PAGE);
            }
            // 更新浏览器地址栏
            window.history.replaceState(null, "", url.toString());
        }

        function applyFiltersFromURL() {
            const url = new URL(window.location.href);
            const selectedValues = {};

            // 遍历所有 URL 参数
            for (const [key, value] of url.searchParams.entries()) {
                if (key.startsWith("filter.")) {
                    const filterKey = key.replace("filter.", ""); // 获取过滤器的字段名

                    // 处理价格区间
                    if (filterKey === "luxwork.price.min" || filterKey === "luxwork.price.max") {
                        const priceKey = filterKey.split(".").pop(); // 获取 min 或 max
                        selectedValues["price"] = selectedValues["price"] || {};
                        selectedValues["price"][priceKey] = parseFloat(value);
                    } else {
                        // 处理其他复选框类型
                        selectedValues[filterKey] = selectedValues[filterKey] || [];
                        selectedValues[filterKey].push(value);
                    }
                }
            }
            
            return selectedValues;
            // // 根据解析的值渲染筛选内容
            // Object.keys(selectedValues).forEach((filterKey) => {
            //     if (filterKey === "price") {
            //         // 设置价格区间
            //         const { min, max } = selectedValues.price;
            //         if (min) document.getElementById("min-price").value = min;
            //         if (max) document.getElementById("max-price").value = max;

            //         // 更新滑块值
            //         const rangeMin = document.getElementById("range-min");
            //         const rangeMax = document.getElementById("range-max");
            //         if (rangeMin && rangeMax) {
            //             rangeMin.value = min || rangeMin.min;
            //             rangeMax.value = max || rangeMax.max;
            //         }
            //     } else {
            //         // 设置复选框选中状态
            //         const checkboxes = document.querySelectorAll(`.filter-section [name="${filterKey}"] ~ div input[type="checkbox"]`);
            //         checkboxes.forEach((checkbox) => {
            //             if (selectedValues[filterKey].includes(checkbox.value)) {
            //                 checkbox.checked = true;
            //             }
            //         });
            //     }
            // });

            // // 初始化商品列表和过滤器
            // getSelectedCheckboxValues();
             // 如果有顶部标签渲染逻辑
        }

        // 定义统一的处理函数
        function handleCheckboxChange(event) {
            if (event.target.type === 'checkbox') {
              CURRENT_PAGE = 1
                let values = getSelectedCheckboxValues(true);
                renderSelectedFilters(values); 
            }
            
        }

       // 包装 handlePriceChange 为防抖函数
        const debouncedHandlePriceChange = debounce(() => {
          CURRENT_PAGE = 1
            let values =  getSelectedCheckboxValues(true);
            renderSelectedFilters(values); 
        }, 300); // 延迟 300ms 执行
        function debounce(func, delay) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout); // 清除之前的定时器
                timeout = setTimeout(() => {
                    func.apply(this, args); // 调用目标函数
                }, delay);
            };
        }
         // 加载商品数据和分页
         const loadProducts = async (page,filter) => {
                const products = await fetchProducts(page,filter);
                renderProducts(products);
                renderPagination(totalItems, page);
            };

           
            

            const ITEMS_PER_PAGE = 48;
           

            // 获取商品数据
            const fetchProducts = async (page,filter) => {
                if(filter)
                {
                    filter = encodeURIComponent(filter)
                }
                else{
                    filter=''
                }
                
                const response = await fetch(`${baseUrl}/shopify/open/products?page=${page}&filter=${filter}&handle=${handle}&uuid=${uuid}&sortBy=${CURRENT_SORT_BY}`);
                const data = await response.json();
                totalItems = data.total;
                return data.rows;
            };

            // 渲染商品列表
            const getGridCols = (container) => {
                const className = container.className;

                const col = +(className.match(/row-cols-(\d+)/)?.[1] || 1);
                const colMd = +(className.match(/row-cols-md-(\d+)/)?.[1] || 1);
                const colLg = +(className.match(/row-cols-lg-(\d+)/)?.[1] || 1);

                return { col, colMd, colLg };
            };

            const refreshLastItemClass = (container) => {
            const { col, colMd, colLg } = getGridCols(container);
            const items = container.querySelectorAll(":scope > .col");

            items.forEach((item, index) => {
                const i = index + 1;

                item.classList.remove(
                "last-item-dk",
                "last-item-ipad",
                "last-item-tablet",
                "last-item-mobile"
                );

                if (i % colLg === 0) item.classList.add("last-item-dk");
                if (i % colMd === 0) item.classList.add("last-item-ipad");
                if (i % col === 0) item.classList.add("last-item-tablet", "last-item-mobile");
            });
            };

                const renderProducts = (products) => {
                    const productList = document.querySelector(".hdt-collection-products");
                    if (!productList) return;

                    productList.innerHTML = products.map(product => luxRenderProduct(product)).join("");

                    refreshLastItemClass(productList);

                    document.body.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                };

            // 渲染分页控件
const renderPagination = (totalItems, currentPage) => {

  let totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  if (totalPages > 200) totalPages = 200;

  const pagination = document.getElementById("lux-pagination");
  pagination.innerHTML = "";

  // 上一页
  if (currentPage > 1) {
    const prevItem = document.createElement("li");
    prevItem.className = "page-item";

    const link = document.createElement("a");
    link.className = "pagination__item pagination__item--prev pagination__item-arrow page-link motion-reduce";
    link.setAttribute("href", "#");
    link.setAttribute("aria-label", "前のページ");

    link.innerHTML = `
      <svg width="14" height="14" style="transform: rotate(90deg);" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
        fill="currentColor"></path>
      </svg>
    `;

    link.addEventListener("click", (e) => {
      e.preventDefault();
      CURRENT_PAGE = currentPage - 1;
      getSelectedCheckboxValues(true);
    });

    prevItem.appendChild(link);
    pagination.appendChild(prevItem);
  }

  const maxPagesToShow = 5;
  const hasLeftEllipsis = currentPage > 3;
  const hasRightEllipsis = currentPage < totalPages - 2;

  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(totalPages, currentPage + 2);

  if (hasLeftEllipsis && !hasRightEllipsis) {
    startPage = Math.max(1, totalPages - (maxPagesToShow - 1));
  } else if (!hasLeftEllipsis && hasRightEllipsis) {
    endPage = Math.min(totalPages, maxPagesToShow);
  }

  // 左省略
  if (hasLeftEllipsis) {

    const first = document.createElement("li");
    first.className = "page-item";

    const link = document.createElement("a");
    link.className = "pagination__item page-link";
    link.href = "#";
    link.setAttribute("aria-label", "1ページ");
    link.textContent = "1";

    link.addEventListener("click", (e) => {
      e.preventDefault();
      CURRENT_PAGE = 1;
      getSelectedCheckboxValues(true);
    });

    first.appendChild(link);
    pagination.appendChild(first);

    const ellipsis = document.createElement("li");
    ellipsis.className = "page-item";

    ellipsis.innerHTML = `
      <a href="#" class="pagination__item page-link" aria-label="…ページ">…</a>
    `;

    pagination.appendChild(ellipsis);
  }

  // 页码
  for (let i = startPage; i <= endPage; i++) {

    const li = document.createElement("li");

    if (i === currentPage) {
      li.className = "page-item active";
      li.setAttribute("aria-current", "page");

      li.innerHTML = `
        <a href="#" class="pagination__item page-link" aria-label="${i}ページ">${i}</a>
      `;

    } else {

      li.className = "page-item";

      const link = document.createElement("a");
      link.className = "pagination__item page-link";
      link.href = "#";
      link.setAttribute("aria-label", `${i}ページ`);
      link.textContent = i;

      link.addEventListener("click", (e) => {
        e.preventDefault();
        CURRENT_PAGE = i;
        getSelectedCheckboxValues(true);
      });

      li.appendChild(link);
    }

    pagination.appendChild(li);
  }

  // 右省略
  if (hasRightEllipsis) {

    const ellipsis = document.createElement("li");
    ellipsis.className = "page-item";

    ellipsis.innerHTML = `
      <a href="#" class="pagination__item page-link" aria-label="…ページ">…</a>
    `;

    pagination.appendChild(ellipsis);

    const last = document.createElement("li");
    last.className = "page-item";

    const link = document.createElement("a");
    link.className = "pagination__item page-link";
    link.href = "#";
    link.setAttribute("aria-label", `${totalPages}ページ`);
    link.textContent = totalPages;

    link.addEventListener("click", (e) => {
      e.preventDefault();
      CURRENT_PAGE = totalPages;
      getSelectedCheckboxValues(true);
    });

    last.appendChild(link);
    pagination.appendChild(last);
  }

  // 下一页
  if (currentPage < totalPages) {

    const nextItem = document.createElement("li");
    nextItem.className = "page-item";

    const link = document.createElement("a");
    link.className = "pagination__item pagination__item--prev pagination__item-arrow page-link motion-reduce";
    link.href = "#";
    link.setAttribute("aria-label", "次のページ");

    link.innerHTML = `
      <svg width="14" height="14" style="transform: rotate(-90deg);" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
        fill="currentColor"></path>
      </svg>
    `;

    link.addEventListener("click", (e) => {
      e.preventDefault();
      CURRENT_PAGE = currentPage + 1;
      getSelectedCheckboxValues(true);
    });

    nextItem.appendChild(link);
    pagination.appendChild(nextItem);
  }

};

          

           
        // 渲染已选过滤器
        const renderSelectedFilters = (selectedValues) => {
            const selectedFiltersContainer = document.getElementById("lux-filter-selected-filters");
            selectedFiltersContainer.innerHTML = ""; // 清空顶部过滤器展示

            Object.keys(selectedValues).forEach((filterKey) => {
                const values = selectedValues[filterKey];
                const tag = document.createElement("div");
                if (Array.isArray(values) && values.length > 0) {
                    // 创建过滤器标签
                    
                    tag.className = "lux-filter-filter-tag";
                    tag.innerHTML = `<div><span style=" text-transform: capitalize;">${filterKey}: </span><span style=" font-weight:600;">${values.join(", ")}</span></div>`;
                }
                if(filterKey=="price")
                {
           
                    tag.className = "lux-filter-filter-tag";
                    var price=""
                    if(values.min)
                    {
                        if(values.max)
                        {
                            price=`￥${luxFilterFormatNumber(values.min)} - ￥${luxFilterFormatNumber(values.max)}`
                        }
                        else
                        {
                            price=`￥${luxFilterFormatNumber(values.min)}+`
                        }
                    }
                    else if(values.max){
                        price=` - ￥${luxFilterFormatNumber(values.max)}`
                    }
                    tag.innerHTML = `<div><span style=" text-transform: capitalize;">価格: </span><span style=" font-weight:600;">${price}</span></div>`;
                }
                // 添加删除按钮
                const removeBtn = document.createElement("span");
                removeBtn.className = "lux-filter-remove-filter";
                removeBtn.textContent = "×";

                removeBtn.onclick = () => {
                    let values1 = selectedValues[filterKey];
                    if (filterKey=='在庫あり') {
                      values1 = values1.map(value => value === '在庫あり' ? '1' : '0');
                    }
                    // 移除复选框选中状态
                    const checkboxes = document.querySelectorAll(`.lux-filter-section h4[name="${filterKey}"] + div input[type="checkbox"]`);
                    checkboxes.forEach((checkbox) => {
                        if (values1.includes(checkbox.value)) {
                            checkbox.checked = false;
                        }
                    });

                    // 清空价格过滤器
                    if (filterKey === "price") {
                        document.getElementById("lux-filter-min-price").value = "";
                        document.getElementById("lux-filter-max-price").value = "";
                        // 创建一个新的 input 事件
                        const inputEvent = new Event("input", {
                            bubbles: true, // 事件会冒泡
                            cancelable: true, // 事件可以被取消
                        });

                        // 触发 input 事件
                        document.getElementById("lux-filter-min-price").dispatchEvent(inputEvent);
                        document.getElementById("lux-filter-max-price").dispatchEvent(inputEvent);
                    }

                    // 重新加载过滤器和商品
                  CURRENT_PAGE = 1
                    let values =  getSelectedCheckboxValues(true);
                    renderSelectedFilters(values);
                };

                tag.appendChild(removeBtn);
                selectedFiltersContainer.appendChild(tag);
            
            });

            // 添加清除所有过滤器按钮
            if (Object.keys(selectedValues).length > 0) {
                const clearAll = document.createElement("div");
                clearAll.className = "lux-filter-clear-all-filters";
                clearAll.textContent = "すべての条件を解除";
                clearAll.onclick = () => {
                    // 清除所有复选框状态
                    const checkboxes = document.querySelectorAll('.lux-filter-section input[type="checkbox"]');
                    checkboxes.forEach((checkbox) => (checkbox.checked = false));

                    // 清空价格输入
                    const minPriceInput = document.getElementById("lux-filter-min-price");
                    const maxPriceInput = document.getElementById("lux-filter-max-price");
                    if (minPriceInput && maxPriceInput) {
                        minPriceInput.value = "";
                        maxPriceInput.value = "";
                    }
                    // 创建一个新的 input 事件
                    const inputEvent = new Event("input", {
                        bubbles: true, // 事件会冒泡
                        cancelable: true, // 事件可以被取消
                    });

                    // 触发 input 事件
                    minPriceInput.dispatchEvent(inputEvent);
                    maxPriceInput.dispatchEvent(inputEvent);
                    // 清空顶部过滤器
                    selectedFiltersContainer.innerHTML = "";

                    // 重新加载商品列表
                  CURRENT_PAGE = 1
                    let values =  getSelectedCheckboxValues(true);
                    renderSelectedFilters(values);
                };
                selectedFiltersContainer.appendChild(clearAll);
            }
        };


        function generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
                const random = Math.random() * 16 | 0; // 生成随机数
                const value = char === 'x' ? random : (random & 0x3 | 0x8); // 确保符合 UUID v4 标准
                return value.toString(16); // 转换为十六进制
            });
        }
